import Vue from 'vue';
import axios from "axios"
import { store } from "./store-init"
import { langUserGet } from "./utils"

const version = "0.9.4";
const mode = "prod";

let mainServer,
    localDNS = 'dantrix.pro',
    publicWebURI = 'https://web.dantrix.pro',
    isDev = false;

switch (mode) {
    
    case 'prod':
        mainServer = 'https://api.dantrix.pro/sites';
        publicWebURI = 'http://localhost:8080';
        isDev = true;
        Vue.config.productionTip = false;
        break;

    case 'dev':
        mainServer = 'https://api.dantrix.pro/sites-dev';
        publicWebURI = 'http://localhost:8080';
        isDev = true;
        Vue.config.productionTip = false;
        break;

    case 'docker':
        mainServer = 'http://localhost:8001/sites-api';
        publicWebURI = 'http://localhost:8080';
        isDev = true;
        Vue.config.productionTip = false;
        break;
}

const apiURIMain = mainServer + '/img/render/';

axios.defaults.maediaImageRender = apiURIMain;
axios.defaults.timeout = 30000;
axios.defaults.withCredentials = false;

axios.defaults.switchAPI = (waty) => {
    switch (waty) {
        case 'consumer':
            axios.defaults.baseURL = mainServer + '/api';
            axios.defaults.isSales = false;
            break;
    }
};

axios.defaults.switchAPI('consumer');

axios.interceptors.request.use((config) => {
    config.headers['Content-Type'] = 'application/json';

    if (store.getters.accountGetToken) {
        config.headers['AUTH-TOKEN'] = store.getters.accountGetToken;
    } else if (typeof config.headers['AUTH-TOKEN'] != 'undefined') {
        delete config.headers['AUTH-TOKEN'];
    }

    config.headers['Working-DNS'] = localDNS;
    config.headers['Working-LANG'] = langUserGet();

    if (
        axios.defaults.headers.common &&
        axios.defaults.headers.common['X-Requested-With']
    ) {
        delete axios.defaults.headers.common['X-Requested-With'];
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    return response.data;
}, (error) => {
    return Promise.reject(error);
});

export {
    isDev,
    mainServer,
    version,
    publicWebURI
};